// ------------------------------ title animation -----------------------------
document.addEventListener("DOMContentLoaded", (event) => {
  const titles = document.querySelectorAll(".animate-title, .animate-title-init");
  if(!titles.length) return;

  titles.forEach(title => {
    const words = title.textContent.trim().split(/\s+/);
    title.innerHTML = words.map((word, index) => {
      const chars = word.split("").map(char => `<span>${char}</span>`).join("");
      let wordHTML = `<span class="word" style="white-space: nowrap;">${chars}</span>`;
      if(index < words.length - 1){
        wordHTML += " <span class='spance'>&nbsp;</span>";
      }
      return wordHTML;
    }).join("");

    // pick speeds depending on class
    let config = {
      overlapPercent: 0.2,
      staggerTime: 0.03,
      goldDuration: 0.3
    };

    if(title.classList.contains("animate-title")){
      if(title.getAttribute('data-speed')){
        config = {
          overlapPercent: 0.2,
          staggerTime: parseInt(title.getAttribute('data-speed')) * 0.01, // slower letters
          goldDuration: 0.5  // smoother/slower fade
        };
      }else{
        config = {
          overlapPercent: 0.2,
          staggerTime: 0.03, // slower letters
          goldDuration: 0.5  // smoother/slower fade
        };
      }
    }
    if (title.classList.contains("animate-title-init")) {
      // faster or slower values for init
      config = {
        overlapPercent: 0.25,
        staggerTime: 0.05,
        goldDuration: 0.4
      };
      const letters = title.querySelectorAll("span.word span");
      animateLetters(letters, config);
      return;
    }

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const letters = entry.target.querySelectorAll("span.word span");
          animateLetters(letters, config);
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      threshold: 0,
      rootMargin: "0px 0px -40% 0px"
    });
    observer.observe(title);
  });

  function animateLetters(letters, { overlapPercent, staggerTime, goldDuration }) {
    const totalLetters = letters.length;
    const tl = gsap.timeline();

    tl.to(letters, {
      color: "#c2ab62",
      stagger: staggerTime,
      duration: goldDuration
    });

    const overlapStart = (totalLetters * staggerTime) * overlapPercent;

    tl.to(letters, {
      color: "#0d0d0d",
      stagger: staggerTime,
      duration: goldDuration
    }, overlapStart);
  }
});

// document.addEventListener("DOMContentLoaded", (event) => {
// // window.addEventListener("load", function () {
//   const titles = document.querySelectorAll(".animate-title, .animate-title-init");
//   if (!titles.length) return;
//   titles.forEach(title => {
//     // const words = title.textContent.trim().split(" ");
//     // title.innerHTML = words.map(word => {
//     //   const chars = word.split("").map(char => `<span>${char}</span>`).join("");
//     //   return `<span class="word" style="white-space: nowrap;">${chars}</span>`;
//     // }).join(" <span class='spance'>&nbsp;</span>");
//     // if (title.classList.contains("animate-title-init")) {
//     //   const letters = title.querySelectorAll("span.word span");
//     //   animateLetters(letters, 0.5);
//     //   return;
//     // }
//     const words = title.textContent.trim().split(/\s+/);
//     title.innerHTML = words.map((word, index) => {
//       const chars = word.split("").map(char => `<span>${char}</span>`).join("");
//       let wordHTML = `<span class="word" style="white-space: nowrap;">${chars}</span>`;
//       // Add spacer only if not the last word
//       if (index < words.length - 1) {
//         wordHTML += " <span class='spance'>&nbsp;</span>";
//       }
//       return wordHTML;
//     }).join("");
//     if (title.classList.contains("animate-title-init")) {
//       const letters = title.querySelectorAll("span.word span");
//       animateLetters(letters, 0.2);
//       return;
//     }
//     const observer = new IntersectionObserver((entries, observer) => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           const letters = entry.target.querySelectorAll("span.word span");
//           animateLetters(letters, 0.2);
//           observer.unobserve(entry.target);
//         }
//       });
//     }, {
//       root: null,
//       threshold: 0,
//       rootMargin: "0px 0px -40% 0px"
//     });
//     observer.observe(title);
//   });
//   function animateLetters(letters, overlapPercent) {
//     const totalLetters = letters.length;
//     const goldDuration = 0.3;
//     const staggerTime = 0.03;
//     const tl = gsap.timeline();
//     tl.to(letters, {
//       color: "#c2ab62",
//       stagger: staggerTime,
//       duration: goldDuration
//     });
//     const overlapStart = (totalLetters * staggerTime) * overlapPercent;
//     tl.to(letters, {
//       color: "#0d0d0d",
//       stagger: staggerTime,
//       duration: goldDuration
//     }, overlapStart);
//   }
// });
// ------------------------------ title animation ------------------------------
document.addEventListener("DOMContentLoaded", (event) => {
  swiper = new Swiper(".product-row-slide.swiper", {
    slidesPerView: "auto",
    loop: true,
    a11y: false,
    freeMode: true,
    resizeObserver: false,
    // mousewheel: {
    //   releaseOnEdges: true,
    // },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination:{
      el: ".swiper-pagination",
    },
    navigation:{
      nextEl: ".bottom-pagination-arrows .swiper-button-next",
      prevEl: ".bottom-pagination-arrows .swiper-button-prev"
    }
  });
});
// function productrow(){
//   var productslider=[];
//   document.querySelectorAll('.product-media-inr').forEach(function(Element,index){
//     let productid = Element.dataset.id;
//     let nextbutton = Element.querySelector('.swiper-button-next');
//     let prevbutton = Element.querySelector('.swiper-button-prev');
//     let swiperObject={
//       loop:eval(Element.dataset.loop),
//       slidesPerView: "auto",
//       a11y: false,
//       navigation: {
//         nextEl:nextbutton,
//         prevEl:prevbutton,
//       },
//     };    
//     productslider[productid]=new Swiper(Element,swiperObject);
//   });
// }
// productrow();
function productrow() {
  var productslider = [];
  if(document.querySelectorAll('.product-media-inr')) document.querySelectorAll('.product-media-inr').forEach(function (Element) {
    if (!(Element instanceof HTMLElement)) return;
    let productid = Element.dataset.id;
    let nextbutton = Element.querySelector('.swiper-button-next');
    let prevbutton = Element.querySelector('.swiper-button-prev');
    if(!nextbutton || !prevbutton) return;
    let swiperObject = {
      loop: eval(Element.dataset.loop),
      slidesPerView: "auto",
      a11y: false,
      resizeObserver: false,
      navigation: {
        nextEl: nextbutton,
        prevEl: prevbutton,
      },
      breakpoints: {
        0: {
          enabled: false
        },
        991: {
          enabled: true
        }
      }
    };
    productslider[productid] = new Swiper(Element, swiperObject);
  });
}
productrow();
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(window.Shopify.routes.root + `/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=6&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      productrow();
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open(){
    this.predictiveSearchResults.style.display = 'block';
    document.querySelector('.searchbox').classList.add('active-search');
  }
  close(){
    this.predictiveSearchResults.style.display = 'none';
    document.querySelector('.searchbox').classList.remove('active-search');
  }
  debounce(fn, wait){
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click',function(e){
    if(document.querySelector('body').classList.contains('open-search')){
      document.querySelector('body').classList.toggle('open-search');
      document.querySelector('body').classList.remove('open-drawer','open-sort','open-filter','active-acc');    
      document.querySelector('.shopify-section-header.sticky_header').classList.add('solid_header');    
    }else{
      if(window.innerWidth < 992){
        if(document.querySelector('body').classList.contains('open-currency')){
          document.querySelector('body').classList.remove('open-menu','open-currency','active-acc');
        }else{
          document.querySelector('body').classList.toggle('open-menu');
          document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter','active-acc','open-outfit');
        }
      }
    }
    setTimeout(() => {
      if(document.querySelector('.navmobile-dropdown.active')){
        document.querySelector('.navmobile-dropdown.active').classList.remove('active');
      }
    }, 500);
  });
});
document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.add('opening-search');
    setTimeout(() => {
      document.querySelector('body').classList.remove('opening-search');
      document.querySelector('body').classList.toggle('open-search');
    }, 300);
    document.querySelector('body').classList.remove('open-drawer','open-sort','open-filter');
    // document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    document.querySelector(".searchbox #Search").focus();
    var Swipes = new Swiper('.popular_items_slider', {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 12,
      a11y: true,
      navigation: {
        nextEl: ".popular_items .swiper-button-next",
        prevEl: ".popular_items .swiper-button-prev",
      },
    });
  });
});
document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.body.classList.remove('open-menu', 'active-acc');
});
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      if (sizeList.dataset.quickAddBound === 'true') return;
      sizeList.dataset.quickAddBound = 'true';
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let nlSize = sizeList.dataset.nlSize;
        let countryCode = sizeList.dataset.isoCode;
        let displaySize = sizeList.textContent.trim();
        
        let error_grid_outer;
        if(sizeList.closest('.opg-product-block')){
          error_grid_outer = sizeList.closest('.opg-product-block');
        }else{
          error_grid_outer = sizeList.closest('.snippet-product-grid');
        }
        let error_grid = error_grid_outer.querySelector('.grid-error');
        
        // Build properties if size conversion happened
        let properties = {};
        if (nlSize && displaySize && displaySize !== nlSize) {
          properties['Size guide'] = 'NL ' + nlSize + ' / ' + countryCode + ' ' + displaySize;
        }
        
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1,
            'properties': properties
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422) {
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
                document.querySelectorAll('.cart-count').forEach((cartCountItem) => {
                  cartCountItem.innerHTML = ' ['+ cart_count +']';
                });
              }else{
                document.querySelectorAll('.cart-count').forEach((cartCountItem) => {
                  cartCountItem.innerHTML = '';
                });
              }
            })
            .catch(function(error) {
              console.log(error);
            })
            console.log(data);
            const addedItem = data.items[0];
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "add_to_cart",
              ecommerce: {
                currency: Shopify.currency.active,
                value: addedItem.price / 100,
                items: [{
                  item_id: addedItem.product_id,
                  item_name: addedItem.product_title,
                  item_category: addedItem.product_type,
                  item_variant: addedItem.variant_title,
                  item_variant_id: addedItem.variant_id,
                  price: addedItem.price / 100,
                  quantity: 1
                }]
              }
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });
  }
  quickAddButton();
}
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search','open-currency','open-zoom','open-size-chart');
  }
}
if(document.querySelectorAll('.active_currency'))  document.querySelectorAll('.active_currency').forEach(function(lang_currency){
  lang_currency.addEventListener('click',function(e){
    e.preventDefault();
    if(e.target.classList.contains('ftr-currency')){
      document.body.classList.add('full-currency');
    }
    document.body.classList.add('open-currency');
  });
});
// ================================================ localization ================================================
// if(document.querySelectorAll('.localization-btn'))  document.querySelectorAll('.localization-btn').forEach(function(localization_btn){
//   localization_btn.addEventListener('click',function(e){
//     e.preventDefault();
//   });
// });
// if (!customElements.get("localization-form")) {
//   customElements.define(
//     "localization-form",
//     class LocalizationForm extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           input: this.querySelector(
//             'input[name="locale_code"], input[name="country_code"]'
//           ),
//           button: this.querySelector("button"),
//           panel: this.querySelector(".disclosure__list-wrapper"),
//         };
//         this.elements.button.addEventListener(
//           "click",
//           this.openSelector.bind(this)
//         );
//         this.elements.button.addEventListener(
//           "focusout",
//           this.closeSelector.bind(this)
//         );
//         this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

//         // Add the event listener to specific links with the "redirect-loc" class
//         this.querySelectorAll("a.redirect-loc").forEach((item) =>
//           item.addEventListener("click", this.onRedirectLinkClick.bind(this))
//         );

//         // Add the event listener to all other internal links within the localization-form
//         this.querySelectorAll("a:not(.redirect-loc)").forEach((item) =>
//           item.addEventListener("click", this.onInternalLinkClick.bind(this))
//         );
//       }

//       hidePanel() {
//         this.elements.button.setAttribute("aria-expanded", "false");
//         this.elements.panel.setAttribute("hidden", true);
//       }

//       onContainerKeyUp(event) {
//         if (event.code.toUpperCase() !== "ESCAPE") return;

//         if (this.elements.button.getAttribute("aria-expanded") == "false")
//           return;
//         this.hidePanel();
//         event.stopPropagation();
//         this.elements.button.focus();
//       }

//       onRedirectLinkClick(event) {
//         // For links with the "redirect-loc" class, allow the default link behavior
//         // The "preventDefault" method is not called for these links
//       }
//       // onInternalLinkClick(event) {
//       //   // For other internal links within the localization-form, prevent the default behavior and perform custom actions
//       //   event.preventDefault();
//       //   const form = this.querySelector("form");
//       //   this.elements.input.value = event.currentTarget.dataset.value;
//       //   if (form) form.submit();
//       // }
//       onInternalLinkClick(event) {
//         event.preventDefault();
//         this.elements.input.value = event.currentTarget.dataset.value;
//         this.querySelectorAll(".disclosure__link").forEach(link =>
//           link.classList.remove("disclosure__link--active")
//         );
//         event.currentTarget.classList.add("disclosure__link--active");
//         event.currentTarget.closest('.disclosure').querySelector('.disclosure__button span').textContent = event.currentTarget.textContent;
//         event.currentTarget.closest('.localization-inr').querySelectorAll('.localization-btn .country_change').forEach(function(country_change){
//           if(event.currentTarget.dataset.symbol){
//             country_change.textContent =  event.currentTarget.dataset.symbol;
//           }
//         });
//         this.hidePanel();
//       }
//       openSelector() {
//         this.elements.button.focus();
//         this.elements.panel.toggleAttribute("hidden");
//         this.elements.button.setAttribute(
//           "aria-expanded",
//           (
//             this.elements.button.getAttribute("aria-expanded") === "false"
//           ).toString()
//         );
//       }
//       closeSelector(event) {
//         const isChild =
//           this.elements.panel.contains(event.relatedTarget) ||
//           this.elements.button.contains(event.relatedTarget);
//         if (!event.relatedTarget || !isChild) {
//           this.hidePanel();
//         }
//       }
//     }
//   );
//   document.querySelectorAll(".localization-btn-mb,.localization-btn").forEach((btn) => {
//     btn.addEventListener("click", (e) => {
//       e.preventDefault();

//       const snippet = btn.closest(".snippet-localization");
//       if (!snippet) return;

//       // Collect values from both forms
//       let countryCode = null;
//       let localeCode = null;

//       snippet.querySelectorAll("localization-form").forEach((locForm) => {
//         const activeLink = locForm.querySelector(".disclosure__link--active");
//         if (activeLink && locForm.elements?.input) {
//           locForm.elements.input.value = activeLink.dataset.value;
//         }

//         // Detect which input is inside this form
//         const input = locForm.querySelector('input[name="country_code"], input[name="locale_code"]');
//         if (input?.name === "country_code") {
//           countryCode = input.value;
//         }
//         if (input?.name === "locale_code") {
//           localeCode = input.value;
//         }
//       });

//       // ✅ Build a single hidden form with both values
//       const tempForm = document.createElement("form");
//       tempForm.method = "POST";
//       tempForm.action = "/localization";

//       tempForm.innerHTML = `
//         <input type="hidden" name="form_type" value="localization">
//         <input type="hidden" name="utf8" value="✓">
//         <input type="hidden" name="_method" value="put">
//         <input type="hidden" name="return_to" value="/">
//         ${countryCode ? `<input type="hidden" name="country_code" value="${countryCode}">` : ""}
//         ${localeCode ? `<input type="hidden" name="locale_code" value="${localeCode}">` : ""}
//       `;

//       document.body.appendChild(tempForm);
//       tempForm.submit();
//     });
//   });
// }
// ================================================End localization ================================================
document.addEventListener("DOMContentLoaded", () => {
  
  const elementsWorks = document.querySelectorAll(".mega-nav.has-img .mega-listmenu li");
  const slidePicWorks = document.querySelector("#gallery-work");
  const slidePicsWorks = document.querySelector("#work-images");

  if(slidePicWorks) gsap.set(slidePicWorks, { autoAlpha: 0 });

  elementsWorks.forEach((element, index) => {
    element.addEventListener("mouseenter", function () {
      if(slidePicsWorks) gsap.to(slidePicsWorks, {
        marginTop: `-${173 * index}px`,
        duration: 0.2,
        ease: "power1",
      });
    });

    element.addEventListener("mouseleave", function () {
      gsap.to(element, { color: "initial", duration: 0.2, ease: "power1" });
    });
  });

  window.addEventListener("mousemove", function (e) {
    if(slidePicWorks) gsap.to(slidePicWorks, {
      top: `${e.clientY}px`,
      left: `${e.clientX}px`,
      xPercent: 48,
      yPercent: -48,
      duration: 0.2,
      ease: "power1",
    });
  });

  if(document.querySelector(".mega-nav.has-img .mega-listmenu")) document.querySelector(".mega-nav.has-img .mega-listmenu").addEventListener("mouseenter", function () {
    gsap.to(slidePicWorks, {
      autoAlpha: 1,
      duration: 0.2,
      ease: "power1",
    });
  });

  if(document.querySelector(".mega-nav.has-img .mega-listmenu")) document.querySelector(".mega-nav.has-img .mega-listmenu").addEventListener("mouseleave", function () {
    gsap.to(slidePicWorks, {
      autoAlpha: 0,
      duration: 0.2,
      ease: "power1",
    });
  });


  // const links = document.querySelectorAll('.mega-nav.has-img .mega-listmenu li a');
  // if (!links.length) return;
  // let lastIndex = -1;
  // let activeImg = null;
  // let zCounter = 10;
  // let mouseX = 0, mouseY = 0, posX = 0, posY = 0;
  // const smoothFollow = () => {
  //   if (activeImg) {
  //     posX += (mouseX - posX) * 0.2;
  //     posY += (mouseY - posY) * 0.2;
  //     activeImg.style.left = `${posX + 15}px`;
  //     activeImg.style.top = `${posY}px`;
  //   }
  //   requestAnimationFrame(smoothFollow);
  // };
  // requestAnimationFrame(smoothFollow);
  // links.forEach((link, index) => {
  //   link.addEventListener("mouseenter", (e) => {
  //     const imgWrap = link.querySelector(".mega-hover-img");
  //     if (!imgWrap) return;
  //     const img = imgWrap.querySelector('img');
  //     if (!img) return;
  //     const rect = link.getBoundingClientRect();
  //     mouseX = e.clientX - rect.left;
  //     mouseY = e.clientY - rect.top;
  //     posX = mouseX;
  //     posY = mouseY;
  //     let fromTop = index > lastIndex;
  //     if (lastIndex === -1) fromTop = false;
  //     document.querySelectorAll('.mega-hover-img').forEach(imgEl => {
  //       imgEl.style.opacity = '';
  //       imgEl.style.visibility = '';
  //     });
  //     zCounter++;
  //     imgWrap.style.zIndex = zCounter;
  //     img.style.transition = 'none';
  //     img.style.transform = fromTop ? 'translateY(-100%)' : 'translateY(100%)';
  //     imgWrap.style.left = `${posX + 15}px`;
  //     imgWrap.style.top = `${posY}px`;
  //     imgWrap.style.opacity = '1';
  //     imgWrap.style.visibility = 'visible';
  //     imgWrap.offsetHeight;
  //     requestAnimationFrame(() => {
  //       img.style.transition = 'transform 0.4s ease';
  //       img.style.transform = 'translateY(0)';
  //     });
  //     activeImg = imgWrap;
  //     lastIndex = index;
  //   });
  //   link.addEventListener("mousemove", (e) => {
  //     const rect = link.getBoundingClientRect();
  //     mouseX = e.clientX - rect.left;
  //     mouseY = e.clientY - rect.top;
  //   });
  //   link.addEventListener("mouseleave", () => {
  //     const imgWrap = link.querySelector(".mega-hover-img");
  //     if (!imgWrap) return;

  //     const img = imgWrap.querySelector('img');
  //     if (!img) return;

  //     img.style.transform = 'translateY(-100%)';

  //     setTimeout(() => {
  //       imgWrap.style.opacity = '0';
  //       imgWrap.style.visibility = 'hidden';
  //       img.style.transition = '';
  //       img.style.transform = '';
  //       if (activeImg === imgWrap) activeImg = null;
  //     }, 400);
  //   });
  // });
});
function cartNotification(cartIds) {
  fetch(window.Shopify.routes.root + "?section_id=cart-notification")
    .then((response) => response.text())
    .then((responseText) => {
      const cnID = "cart-notification";
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.querySelector(".cart_popup");
      const source = html.getElementById(cnID);
      if (source && destination) destination.innerHTML = source.innerHTML;
      const cartIdsArray = Array.isArray(cartIds) ? cartIds : [cartIds];
      let selectedHTML = "";
      cartIdsArray.forEach(id => {
        const itemEl = document.querySelector(".ch_items .cn_" + id);
        if (itemEl) {
          selectedHTML += itemEl.outerHTML;
        }
      });
      if (selectedHTML) {
        document.querySelector(".ch_items").innerHTML = selectedHTML;
      }
      const popup = document.querySelector(".cart_popup");
      if (popup) {
        setTimeout(() => {
          popup.classList.add("active");
          setTimeout(() => {
            popup.classList.remove("active");
            setTimeout(() => {
              popup.innerHTML = "";
            }, 300);
          }, 4000);
        }, 500);
      }
      document.body.addEventListener("click", function (e) {
        if(!popup) return;
        if(e.target.closest(".cn-close")) {
          e.preventDefault();
          popup.classList.remove("active");
          setTimeout(() => (popup.innerHTML = ""), 300);
          return;
        }
        if(e.target.closest(".cn-link")) {
          e.preventDefault();
          document.body.classList.add("open-drawer");
          popup.classList.remove("active");
          setTimeout(() => (popup.innerHTML = ""), 300);
          return;
        }
        if(!popup.contains(e.target)) {
          popup.classList.remove("active");
          setTimeout(() => (popup.innerHTML = ""), 300);
        }
      });
    });
}
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      if(!document.querySelector('body').classList.contains('do-not-open-menu')) document.body.classList.add('desk-menu-open');
      // document.body.classList.remove('open-filter');
    });
    navList.addEventListener('mouseout', function(){
      document.body.classList.remove('desk-menu-open');
      setTimeout(() => {
        document.querySelector('body').classList.remove('do-not-open-menu')
      },1000);
    });
  });
}
if(document.querySelectorAll('.snippet-product-grid')) document.querySelectorAll('.snippet-product-grid').forEach((grid) => {
  grid.addEventListener('mouseover', function () {
    let gridMeta = grid.querySelector('.grid-meta');
    if (!gridMeta) return;
    let top = gridMeta.querySelector('.grid-meta-top');
    let btm = gridMeta.querySelector('.grid-meta-btm');
    if (!top || !btm) return;
    let topHeight = top.offsetHeight;
    let btmHeight = btm.offsetHeight;
    let maxHeight = Math.max(topHeight, btmHeight);
    gridMeta.style.height = maxHeight + 'px';
  });
});
document.addEventListener("DOMContentLoaded", function() {
  let recentlyViewedProducts = [];
  try {
    recentlyViewedProducts = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
  } catch (e) {
    recentlyViewedProducts = [];
  }

  const count = recentlyViewedProducts.length;

  if (count === 0) {
    document.querySelectorAll('.megamenu-recently-view').forEach(function(megamenu) {
      megamenu.style.display = 'none';
    });
  } else {
    document.querySelectorAll('.megamenu-recently-view').forEach(function(megamenu) {
      megamenu.style.display = 'block';
    });
    document.querySelectorAll('.recently-view-count').forEach(function(view_count) {
      view_count.textContent = `(${count})`;
    });
  }
});
// ------------------------------------------ wishlist notification ------------------------------------------
var wc_product = '';
var wcProductID = '';
var wcVariantID = '';
var wcProductTitle = '';
var wcProductURL = '';
var wcVariantJSON = '';
var wcProductImg = '';
var wcProductOutfit = '';
window.$wc_wishlist_addToWishlist = (self) => {
  wc_product = self.closest('.th_prd_wl_btn, .th_wl_col_btn').getAttribute('data-product-handle');
  wcVariantID = parseInt(self.closest('.th_prd_wl_btn, .th_wl_col_btn').getAttribute('data-variant_id'));
  wcProductID = parseInt(self.closest('.th_prd_wl_btn, .th_wl_col_btn').getAttribute('data-product_id'));
  wcProductTitle = self.closest('.th_prd_wl_btn, .th_wl_col_btn').getAttribute('data-product-title');
  wcProductURL = self.closest('.th_prd_wl_btn, .th_wl_col_btn').getAttribute('data-product-url');
  wcVariantJSON = self.closest('.th_prd_wl_btn, .th_wl_col_btn').getAttribute('data-variant-json');
  wcProductImg = self.closest('.th_prd_wl_btn, .th_wl_col_btn').getAttribute('data-product-img');
  wcProductOutfit = self.closest('.th_prd_wl_btn, .th_wl_col_btn').getAttribute('data-outfit');
  return 0;
}
window.$th_wishlistAdd_callback_successMessage = (message) => {
  if(message.includes('added')){
    renderWishlistPopup(wc_product, wcProductID, wcVariantID,wcProductTitle,wcProductURL,wcVariantJSON,wcProductImg,wcProductOutfit);
  }
}
async function renderWishlistPopup(productHandle, productId, variantId, productTitle, productURL, variantJSON, productImg, productOutfit) {
  try {
    // Parse the variant JSON from the data attribute
    let variant = {};
    try {
      variant = JSON.parse(variantJSON);
    } catch (e) {
      console.warn('Invalid variant JSON', e);
      return;
    }

    Shopify.formatMoney = function(cents, format) {
      if (typeof cents == 'string') {
      cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /{{\s*(\w+)\s*}}/;
      var formatString = (format || this.money_format);
      function defaultOption(opt, def) {
          return (typeof opt == 'undefined' ? def : opt);
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal = defaultOption(decimal, '.');
          if (isNaN(number) || number == null) {
              return 0;
          }
          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              cents = parts[1] ? (decimal + parts[1]) : '';
          return dollars + cents;
      }
      switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
          case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
          case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
          case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
      }
      return formatString.replace(placeholderRegex, value);
    };

    // Ensure HTTPS for images
    const ensureHttps = (src) => {
      if (!src) return '';
      if (src.startsWith('//')) return 'https:' + src;
      if (src.startsWith('http')) return src;
      return src;
    };
    // Determine product image
    let imageSrc = '';
    if (productImg) {
      imageSrc = typeof productImg === 'string'
        ? productImg
        : (productImg || '');
    }
    if (!imageSrc && variant.image) imageSrc = variant.image;
    imageSrc = ensureHttps(imageSrc);
    // Extract price (already in variant JSON?)
    const price = variant.price || 0;
    // Extract color and size from options (if available)
    const optionMap = {};
    if (variant.option1) optionMap['option1'] = variant.option1;
    if (variant.option2) optionMap['option2'] = variant.option2;
    if (variant.option3) optionMap['option3'] = variant.option3;
    const sizeValue = optionMap['option1'] || '';
    const colorValue = optionMap['option2'] || '';
    // Build HTML using already available attributes
    const html = `
      <div class="wishlist-success-msg">
        <div class="cn-head">
          <p class="body-head">Added to Wishlist</p>
          <div class="wn-close">
            <a href="#">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <path d="M18.5391 11.4644L11.468 18.5354" stroke="currentColor"/>
                <path d="M18.5391 18.5356L11.468 11.4646" stroke="currentColor"/>
              </svg>
            </a>
          </div>
        </div>
        <div class="ch_items">
          <div class="cn_left">
            <a href="${productURL}" class="media">
              <img src="${imageSrc}" alt="${productTitle}" width="200" height="200" loading="lazy" />
            </a>
          </div>
          <div class="cn_right">
            <div class="cn_right-top">
              <div class="cn-meta-title">
                <p><a href="${productURL}">${productTitle}</a></p>
                ${productOutfit ? '' : `<p>${Shopify.formatMoney(price)}</p>`}
              </div>
              ${colorValue ? `<div class="cn-meta-color"><span>Colour: ${colorValue}</span></div>` : ''}
            </div>
          </div>
        </div>
        <div class="cn_btn">
          <div class="wn-link"><a href="#">Undo</a></div>
        </div>
      </div>
    `;

    // Inject into popup (same as before)
    const popup = document.querySelector('.wishlist_popup');
    if (popup) {
      const container = popup.querySelector('.wishlist-grid') || popup;
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html.trim();
      container.prepend(wrapper.firstElementChild);
      setTimeout(() => {
        document.querySelector('.wishlist-success-msg')?.classList.add("active-wishlist");
      }, 100);

      setTimeout(() => {
        document.querySelector('.wishlist-success-msg')?.classList.remove("active-wishlist");
        setTimeout(() => { popup.innerHTML = ''; }, 3000);
      }, 5000);
      document.body.addEventListener("click", function(e) {
        if (!popup.contains(e.target)) popup.innerHTML = "";
        if (e.target.closest('.wn-close')) {
          e.preventDefault();
          popup.innerHTML = "";
        }
      });
      document.querySelector('.wn-link a').addEventListener('click', function(e) {
        e.preventDefault();
        fetch("https://wishlist.webcontrive.com/wishlist-club/public/api/v3/remove", {
          method: "POST",
          headers: { "Content-Type": "text/plain" },
          body: JSON.stringify({
            shop: Shopify.shop,
            product_id: wcProductID,
            variant_id: wcVariantID,
            customer_id: parseInt(document.body.getAttribute('data-customer')),
            ip: document.cookie.match(/(?:^|; )wlcIp=([^;]*)/)?.[1] || null
          })
        })
        .then(res => res.json())
        .then(() => {
          var product_listing = JSON.parse(localStorage.getItem('th_wishlist_products_list'));
          for (var index = 0; index < product_listing.length; index++) {
            let sixMinutesAgo = Date.now() - (6 * 60 * 1000);
            product_listing[index].timestamp = sixMinutesAgo;
          }
          record = product_listing;
          localStorage.setItem('th_wishlist_products_list', JSON.stringify(product_listing));
          $th_refreshWishlistItems();
          // setTimeout(() => {
          //   $th_refreshWishlistItems();
          //   // popup.innerHTML = "";
          // }, 500);
          document.querySelector('.wishlist-success-msg')?.classList.remove("active-wishlist");
        })
        .catch(err => console.error("Error removing from wishlist:", err));
      });
    }
  } catch (e) {
    console.error('Wishlist popup render error:', e);
  }
}